import { useEffect, useState } from 'react'
import { Button, ButtonGroup } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import RequestWithdrawal from './RequestWithdrawal'
import RefferalAndEarning from './RererralAndEarning'
import WithdrawableHistory from './WithdrawalHistory'
import { me } from '../../Services/DashboardServices'
import { FaRegCopy } from 'react-icons/fa'
import toast from 'react-hot-toast'

const Banner = () => {
    const [tab, setTab] = useState("requestWithdrawal")
    const [loading, setLoading] = useState(false)
    const [userData, setUserData] = useState(null)

    const user = useSelector((state) => state.auth.data);


    const handleGetUser = async () => {
        setLoading(true)
        const response = await me(user?.id);
        if (response?.code === 200) {
            setUserData(response?.result?.user)
            setLoading(false)
        }
        else {
            setLoading(false)
        }
    }

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => toast.success("Copied to clipboard!"))
            .catch((err) => console.error("Copy failed", err));
    };


    useEffect(() => {
        if (user?.id) {
            handleGetUser(user?.id);
        }
    }, [user?.id])
    return (
        <>
            <div className="container ">

                {userData && (

                    <div className="card border-0 shadow-sm p-3">
                        <div className="row g-2">
                            <div className="col-12">
                                <h2 className='fw-bold' style={{ color: "#41ABC6" }}>Welcome,  <span className='text-capitalize'>{userData?.name}</span></h2>
                                <p className='text-muted '>Manage your referral and wallets</p>
                            </div>

                            <div className="col-lg-6">
                                <div className="card d-flex justify-content-center h-100 border-0 bg-light p-3">
                                    <div>

                                        <p className='text-muted mb-0'>Your referral link</p>
                                        <div className="row">
                                            <div className="col">

                                                <p className='fw-bold mb-0'>https://popgop.com.pk/?ref={userData?.referral_code}</p>
                                            </div>
                                            <div className="col-auto">
                                                <FaRegCopy className='cursor-pointer' onClick={() => copyToClipboard(`https://popgop.com.pk/?ref=${userData?.referral_code}`)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="col-lg-3 d-none">
                                <div className="card d-flex justify-content-center h-100 border-0 bg-light p-3">
                                    <p className='text-muted mb-0'>Your referral Code</p>
                                    <p className='fw-bold mb-0'>{userData?.referral_code}</p>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <div className="card d-flex justify-content-center h-100 border-0 bg-light p-3">
                                    <p className='text-muted mb-0'>Wallet balance</p>
                                    <p className='fw-bold mb-0 s-22'>PKR {userData?.wallet_balance}</p>
                                </div>
                            </div>


                            <div className="col-lg-3">
                                <div className="card d-flex justify-content-center h-100 border-0 bg-light p-3">
                                    <p className='text-muted mb-0'>Refferal Pending Amount</p>
                                    <p className='fw-bold mb-0 s-22'>PKR {userData?.pending_amount}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="col-lg-12 mt-4">
                    <div className='p-1 bg-light shadow-sm rounded'>
                        <ButtonGroup className='w-100' aria-label="Basic example">
                            <Button onClick={() => setTab("requestWithdrawal")} className={`${tab === "requestWithdrawal" ? "bg-badge " : "bg-light text-dark"} border-0`} >Request Withdrawal</Button>
                            <Button onClick={() => setTab("referralsAndEarning")} className={`${tab === "referralsAndEarning" ? "bg-badge " : "bg-light text-dark"} border-0`}>Referrals and Earning</Button>
                            <Button onClick={() => setTab("withdrawalHistory")} className={`${tab === "withdrawalHistory" ? "bg-badge " : "bg-light text-dark"} border-0`} >Withdrawal History</Button>
                        </ButtonGroup>
                    </div>
                </div>

                {tab === "requestWithdrawal" && (
                    <div className="col-lg-12 mt-5">
                        <RequestWithdrawal wallet_balance={userData?.wallet_balance} />
                    </div>
                )}

                {tab === "referralsAndEarning" && (
                    <div className="col-lg-12 mt-5">
                        <RefferalAndEarning />
                    </div>
                )}

                {tab === "withdrawalHistory" && (
                    <div className="col-lg-12 mt-5">
                        <WithdrawableHistory />
                    </div>
                )}


            </div>
        </>
    )
}

export default Banner